import { motion } from "framer-motion";
import scrollArrow from "@/assets/brand/scroll-arrow-new.svg";
import methodIntroBg from "@/assets/method-intro-pattern.png";

const MethodIntro = () => {
  const scrollToMethod = () => {
    const methodSection = document.getElementById("desafio");
    if (methodSection) {
      methodSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ backgroundColor: "#0a1628" }}>
      {/* Background pattern */}
      <div className="absolute inset-0">
        <img 
          src={methodIntroBg} 
          alt="" 
          className="w-full h-full object-cover opacity-30"
        />
      </div>
      {/* Dark blue overlay */}
      <div className="absolute inset-0 bg-[#0a1628]/70" />
      
      <div className="container px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-12 text-white">
            Así es como ayudamos a más de{" "}
            <span className="text-gradient-gold">1000 empresarios</span>{" "}
            a elevar el valor de su Capital de Marca®.
          </h2>
          
          {/* Arrow down */}
          <div className="flex justify-center">
            <motion.button
              onClick={scrollToMethod}
              initial={{ opacity: 0, y: -10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="group"
            >
            <motion.img
              src={scrollArrow}
              alt="Scroll"
              className="w-10 h-auto opacity-60 hover:opacity-100 transition-opacity mx-auto"
              animate={{ y: [0, 6, 0] }}
              transition={{
                duration: 1.8,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MethodIntro;
